import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';

/** Owner/Admin only. */
export function useSeniorityMatrix() {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TIME_OFF_KEYS.seniorityMatrix(orgId),
    queryFn: ({ signal }) => timeOffService.getSeniorityMatrix(signal),
    staleTime: 300_000,
    enabled: !!orgId,
  });
}
